<template>
    <div class="mt-3 mb-1 fractions-table">
        <h3 v-if="!selectedObject.data" class="d-flex align-center" @click="$emit('open-and-close-fractions-table')">
            {{$tc('Fraction',2)}} 
            <span class="material-icons" v-if="fractionsTableIsOpen">expand_more</span>
            <span class="material-icons" v-if="!fractionsTableIsOpen">expand_less</span>
        </h3>
        <div v-if="selectedObject.data" class="table-title">
            <span style="text-transform: capitalize">{{`${$tc(selectedObject.type,1)} ${selectedObject.index} | ${$tc('Fraction',2)}`}}</span>
        </div>
        <v-data-table
            dense
            hide-default-footer
            disable-sort
            :headers="headers"
            v-if="!!selectedObject.data ? true : fractionsTableIsOpen"
        >
            <template v-if="!actionTypeIsView" v-slot:header.addButton>
                <thead>
                    <th style="padding-left: 30%">
                        <v-btn x-small depressed class="add-button" @click="openDialog">
                        <v-icon color="#4fa2b7">add_box</v-icon>
                        </v-btn>
                    </th>
                </thead>
            </template>
            <template v-slot:body>
                <tbody>
                    <tr v-for="(item, itemIndex) in fractions" :key="itemIndex" class="cursor-pointer" @click="selectItem(itemIndex,item)">
                        <td>{{item.floorbox_label}}</td>
                        <td>{{item.client_id}}</td>
                        <td>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-on="on">{{item.address}}</span>
                                </template>
                                <span>{{item.address}}</span>
                            </v-tooltip>
                        </td>
                        <td v-if="!selectedObject.data">{{getFloorNumber(item.floor_uuid)}}</td>
                        <td v-if="selectedObject.data">{{getContractStatus(item.contract_status)}}</td>
                        <td v-if="!actionTypeIsView">
                            <app-datatable-action-buttons
                                :user-can-edit="true"
                                @edit="editItem(item, itemIndex)"
                                :user-can-delete="true"
                                @delete="askConfirmationToDeleteItem(item)"
                            />
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-data-table>

        <app-dialog-box
            :open="deleteDialog"
            :title="$t('DeleteItem')"
            :content="$t('DeleteConfirmation') + '?'"
            :main-action-label="$t('No')"
            @mainAction="closeDeleteDialog"
            :secondary-action-label="$t('Yes')"
            @secondaryAction="deleteItem"
        />
        <fraction-form 
            v-if="fractionFormIsOpen"
            :dialog-is-open="fractionFormIsOpen"
            :object-to-edit="itemToEdit.data"
            :all-fractions="selectedObject.data ? false : true"
            :floors="floors"
            :selected-object="selectedObject"
            :cableTypeFiveOptions="cableTypeFiveOptions"
            @close-dialog="closeFractionDialog"
            @create-fraction="$emit('create-fraction', $event)"
            @edit-fraction="saveObject($event)"
        />
    </div>
</template>

<script>
import AppDatatableActionButtons from "@/components/_Molecules/AppDatatableActionButtons";
import AppDialogBox from "@/components/_Molecules/AppDialogBox";
import FractionForm from "./FractionForm.vue"
import { managementDatatableMixin } from "@/mixins/management/managementDatatableMixin";
import { verticalMixin } from "@/mixins/verticalMixin.js";
export default{
    name: "FractionsTable",
    components: {
        AppDatatableActionButtons,
        AppDialogBox,
        FractionForm
    },
    mixins: [managementDatatableMixin, verticalMixin],
    props:{
        actionType: {
            type: String
        },
        groundFloors: {
            type: Array
        },
        undergroundFloors: {
            type: Array
        },
        fractionsTableIsOpen: {
            type: Boolean,
            required: true
        },
        fractions: {
            type: Array
        },
        selectedObject: {
            type: Object
        },
        cableTypeFiveOptions: {
            type: Array
        }
    },
    data() {
        return {
            floors: [],
            fractionFormIsOpen: false,
            deleteDialog: false,
            itemToEdit: {
                data: null,
                index: null
            }
        }
    },
    computed:{
        headers() {
            let headers = [];
            if(!this.selectedObject.data){
                headers = [
                    {
                        text: this.$t('ConnectedTo'),
                        align: 'start',
                        sortable: false,
                        value: 'floorbox_label',
                        width: "20%"
                    },
                    {
                        text: `${this.$t('Client')}`+ ' ID',
                        align: 'start',
                        sortable: false,
                        value: 'client_id',
                        width: "15%"
                    },
                    {
                        text: this.$tc('Address', 1),
                        align: 'start',
                        sortable: false,
                        value: 'address',
                        width: "25%"
                    },
                    {
                        text: this.$tc('Floor',1),
                        align: 'start',
                        sortable: false,
                        value: 'floor_uuid',
                        width: "25%"
                    },
                    {
                        text: null,
                        align: 'start',
                        sortable: true,
                        value: 'addButton',
                    }
                ];
            }else{
                headers = [
                {
                    text: this.$t('ConnectedTo'),
                    align: 'start',
                    sortable: false,
                    value: 'floorbox_label',
                    width: "20%"
                },
                {
                    text: `${this.$t('Client')}`+ ' ID',
                    align: 'start',
                    sortable: false,
                    value: 'client_id',
                    width: "15%"
                },
                {
                    text: this.$tc('Address', 1),
                    align: 'start',
                    sortable: false,
                    value: 'address',
                    width: "25%"
                },
                {
                    text: this.$t('ContractStatus'),
                    align: 'start',
                    sortable: false,
                    value: 'contract_status',
                    width: "25%"
                },
                {
                    text: null,
                    align: 'start',
                    sortable: true,
                    value: 'addButton',
                }
            ];
            }
            return headers;
        },
        /** Indicates if the action type is 'view' */
        actionTypeIsView() {
            return this.actionType === 'view'
        },
    },
    mounted(){
        this.getAllFloors();
        
    },
    watch: {
        undergroundFloors(){
            this.getAllFloors();
        },
        groundFloors(){
            this.getAllFloors();
        }
    },
    methods: {
        /** Closes the delete dialog */
        closeDeleteDialog() {
            this.deleteDialog = false;
        },
        getAllFloors(){
            //get all floors
            const allFloors = [];
            this.groundFloors.forEach(floor =>{
                allFloors.push(
                    {
                        id: floor.uuid,
                        label: `Floor ${floor.index}`
                    }
                );
            });
            this.undergroundFloors.forEach(floor =>{
                allFloors.push(
                    {
                        id: floor.uuid,
                        label: `Floor ${floor.index}`
                    }
                );
            });
            this.floors = allFloors;
        },
        openDialog(){
            this.fractionFormIsOpen = true;
        },
        /** Sets the data of the item to edit and opens the dialog */
        editItem(item, index) {
            this.itemToEdit.data = item;
            this.itemToEdit.index = index;
            this.fractionFormIsOpen = true;
        },
        /** Emits an event to delete an item, based on its type and closes the delete dialog */
        deleteItem() {
            const eventObject = {
                floor_uuid: this.itemToDelete.floor_uuid,
                fraction_uuid: this.itemToDelete.uuid,
            };
            this.$emit('delete-fraction', eventObject)
            this.closeDeleteDialog();
        },
        /** Closes the creation dialog and clears the data */
        closeFractionDialog() {
            this.fractionFormIsOpen = false;
            this.itemToEdit.data = null;
            this.itemToEdit.index = null;
        },
        /** Emits an event to save the object, based on its type, with its data and closes the dialog */
        saveObject(objectData) {
            this.$emit('save-fraction', {
                data: objectData,
            });
        },
        getFloorNumber(floor_uuid){
            const floorIndex = this.getFloorIndex(floor_uuid, this.groundFloors, this.undergroundFloors);
            return `Floor ${floorIndex}`; 
        },
        /** Emits an event to select the clicked item of the table */
        selectItem(itemIndex,item) {
            if(this.selectedObject.data){
                const floorIndex = this.getFloorIndex(item.floor_uuid, this.groundFloors, this.undergroundFloors);
                let eventObject = null;
                if (floorIndex >= 0) {
                    eventObject = {
                        floorIndex: floorIndex,
                        floorType: 'g',
                        fractionIndex: itemIndex
                    }
                } else if (floorIndex < 0) {
                    eventObject = {
                        floorIndex: -(floorIndex) -1 ,
                        floorType: 'u',
                        fractionIndex: itemIndex
                    }
                }
                this.$emit('select-fraction', eventObject)
            }
        },
        getContractStatus(contractId){
            let contractLabel;
            const contracts = this.$store.getters.optionLists_contractTypes;
            contracts.forEach(contract =>{
                if(contract.code === contractId){
                    contractLabel = contract.libelle;
                }
            });
            return contractLabel;
        }
    }

}

</script>
<style>
.fractions-table{
    max-height: 500px !important;
    overflow-y: scroll;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/Buildings/Vertical/FractionsTable.vue